import type React from 'react';

import { type IconifyIconSize, Iconify } from '../Iconify/Iconify';

export type IconTypes =
  | 'add'
  | 'archive'
  | 'arrow-left'
  | 'arrow-right'
  | 'assign'
  | 'collapse'
  | 'copy'
  | 'delete'
  | 'edit'
  | 'expand'
  | 'unarchive'
  | undefined;

export interface IconProps {
  size?: IconifyIconSize;
  className?: string;
  type: IconTypes;
}

/**
 * Maps the icon type to the corresponding Iconify icon.
 */
export const getButtonIcon = (icon?: IconProps): React.ReactNode => {
  if (!icon || !icon.type) return null;

  const { className, size = 'small', type } = icon;

  const iconMap: Record<Exclude<IconTypes, undefined>, string> = {
    add: 'mdi:plus',
    archive: 'mdi:archive',
    'arrow-left': 'mdi:chevron-left',
    'arrow-right': 'mdi:chevron-right',
    assign: 'mdi:account-arrow-right',
    collapse: 'mdi:unfold-less-horizontal',
    copy: 'mdi:content-copy',
    delete: 'mdi:delete',
    edit: 'mdi:pen',
    expand: 'mdi:unfold-more-horizontal',
    unarchive: 'mdi:unarchive',
  };

  return (
    <Iconify
      icon={iconMap[type as Exclude<IconTypes, undefined>]}
      className={className}
      size={size}
    />
  );
};
